import { FC } from "react";

import SubscriptionSummaryMUI from "web/Layout/SubscriptionGroupSummary/SubscriptionSummary/subscriptionSummaryMUI";
import SubscriptionGroupSummaryMUI from "web/Layout/SubscriptionGroupSummary/subscriptionGroupSummaryMUI";
import SubscriptionReceiversMUI from "web/Layout/SubscriptionReceivers/subscriptionReceiversMUI";

import { getIdFromIri } from "web/utils/page/product/subscription/iri";

import restUrls from "web/constants/restUrls";

import {
  FormView,
  HandleToggleReceiversModalFn,
  ISubscriptionAttachment,
  ISubscriptionItemCurrentUserSubscription,
} from "web/types/Subscription";

interface IItemFormToFill {
  item: {
    id: string;
    groupName: string;
    groupPhotoURL: string | null;
    benefitGroupAttachments: ISubscriptionAttachment[];
    benefitGroupType: number | undefined;
    items: ISubscriptionItemCurrentUserSubscription[];
  };
  handleToggleEditModal: HandleToggleReceiversModalFn;
}

const ItemFormToFillMUI: FC<IItemFormToFill> = ({
  item,
  handleToggleEditModal,
}) => {
  const {
    groupName,
    benefitGroupType,
    id: groupId,
    items: subscriptions,
  } = item;

  return (
    <SubscriptionGroupSummaryMUI name={groupName} key={groupId}>
      {subscriptions.map((subscription) => {
        const {
          "@id": _id,
          benefit: { wayChooseOthersInActiveForm },
          name,
          quantity,
          receivers,
          status,
        } = subscription;

        const subscriptionId =
          getIdFromIri(_id, restUrls.employeeSubscriptionItems) ?? "";

        return (
          <SubscriptionSummaryMUI key={_id} name={name} quantity={quantity}>
            <SubscriptionReceiversMUI
              receivers={receivers}
              name={name}
              groupName={groupName}
              subscriptionId={subscriptionId}
              benefitStatus={status}
              wayChooseOthersInActiveForm={wayChooseOthersInActiveForm}
              viewType={FormView.MY_SUBSCRIPTIONS}
              handleToggleReceiversModal={handleToggleEditModal}
              benefitGroupType={benefitGroupType}
            />
          </SubscriptionSummaryMUI>
        );
      })}
    </SubscriptionGroupSummaryMUI>
  );
};

export default ItemFormToFillMUI;
